const data_home_fi = `        
<h3 style="margin-top: 2rem;">Tervetuloa kartoittamaan tilojen aistiesteettömyyttä</h3>
<p>
    Aistiesteettömyydessä ollaan kiinnostuneita siitä, miten miellyttävä ja toimiva ympäristö on aistien näkökulmasta.
    Aistiesteettömyydessä arvioidaan, millainen ympäristö kuormittaa käyttäjiään tai vastaavasti auttaa palautumaan.
    Aistiesteettömät ratkaisut auttavat kaikkia, ja osalle ne ovat sujuvan arjen kannalta välttämättömiä. Hienoa, että haluat
    edistää ympäristön aistiesteettömyyttä!

    <br /><br />
    <a href="https://lasten-aistiesteettomyys.web.app/" style="color: blue; font-weight: 500;">
        Siirry lasten versioon
    </a>
</p>
<h4>Näin pääset alkuun:</h4>
<div>
    <ul>
        <li>Valitse aluksi tila tai tilat, joita haluat kartoittaa aistien näkökulmasta </li>
        <li>Paina alta Aloita kartoitus</li>
        <li>Sen jälkeen sovellus ohjaa sinua eteenpäin</li>
    </ul>
    <p>
        <b>Huom!</b> Kaikki kysymykset on mahdollista ohittaa valitsemalla Ohita kysymys, 
        jolloin ne eivät vaikuta kartoituksen tulokseen. Ominaisuutta voit käyttää, mikäli 
        kysymys ei kosketa kartoittamaasi tilaa tai ei muutoin sovellus siihen.
    </p>
</div>

<p style="font-size: 16px;">
    <i class="material-icons info-icon">info</i>
    Voit tarkastella ja/tai muokata laitteellesi tallennettua kartoitusta painamalla alla olevaa Lataa-painiketta.
</p>
`;

const data_home_en = `
<h3 style="margin-top: 2rem;">Welcome to survey the sensory accessibility of spaces</h3>
<p>
    In sensory accessibility, we are interested in how pleasant and functional the environment is from a sensory point of view. 
    Sensory accessibility assesses what kind of environment puts a strain on its users or, conversely, helps them recover. 
    Sensory accessible solutions help everybody, and for some, they are essential for a fluent everyday life. 
    Great that you want to promote the sensory accessibility of environments! 

    <br /><br />
    <a href="https://lasten-aistiesteettomyys.web.app/" style="color: blue; font-weight: 500;">
        Children's version
    </a>
</p>
<h4>Here is how to get started:</h4>
<div>
    <ul>
        <li>Start by selecting a space or spaces   that you want to survey from the sensory accessibility point of view</li>
        <li>Click on Start the survey below</li>
        <li>The application will then lead you forward in the survey</li>
    </ul>
    <p>
        <b>NB:</b> All questions can be skipped by selecting Skip question, in which case they do not influence the result 
        of the survey. You can use this feature if the question does not apply to the space you are surveying or is otherwise 
        not applicable.
    </p>
</div>

<p style="font-size: 16px;">
    <i class="material-icons info-icon">info</i>
    You can view and/or edit the survey saved on your device by clicking <i>Upload</i> button below.
</p>
`;

export { data_home_en, data_home_fi }